import { actionCreatorFactory } from 'typescript-fsa';
import { IApiTimezone } from '@cbridge-packages/api';

export namespace DictTimezoneAction {
  const actionCreator = actionCreatorFactory('DICT_TIMEZONE');

  export const loadList = actionCreator.async<void, IApiTimezone[]>('LOAD_LIST');

  export const destroy = actionCreator('DESTROY');
}
